import DepreciationSection from 'containers/assets/edit_sections/AssetsEditDepreciationSection';
import FilesSection from 'containers/assets/edit_sections/AssetsEditFilesSection';
import FormSection from 'containers/assets/edit_sections/AssetsEditFormSection';
import HistoricsSection from 'containers/assets/edit_sections/AssetsEditHistoricsSection';
import NotesSection from 'containers/assets/edit_sections/AssetsEditNotesSection';
import BillSection from 'containers/assets/edit_sections/AssetsEditBill';
import CustomsDocumentsSection from 'containers/assets/edit_sections/AssetsEditCustomsDocuments';

export default {
  DepreciationSection,
  FilesSection,
  FormSection,
  HistoricsSection,
  NotesSection,
  BillSection,
  CustomsDocumentsSection,
};



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/index.js